(function () {
  function extractGrams(title) {
    var t = title.toLowerCase().replace(',', '.');
    var kgMatch = t.match(/(\d+(?:\.\d+)?)\s*kg/);
    if (kgMatch) return Math.round(parseFloat(kgMatch[1]) * 1000);
    var gMatch = t.match(/(\d+(?:\.\d+)?)\s*g\b/);
    if (gMatch) return Math.round(parseFloat(gMatch[1]));
    return null;
  }

  function pricePerKg(priceInCents, grams) {
    return (priceInCents / 100) / (grams / 1000);
  }

  function updateBadge(selectedVariantId) {
    var variants = window.migaVariants || [];
    var container = document.getElementById('miga-savings-badges');
    if (!container || !variants.length) return;
    container.innerHTML = '';

    var selected = variants.filter(function(v){ return v.id == selectedVariantId; })[0];
    if (!selected) return;

    var selectedGrams = extractGrams(selected.title);
    if (!selectedGrams || selectedGrams <= 250) return;

    // Baseline: najniższa cena/kg wśród małych paczek
    var smallVariants = variants.filter(function(v){
      var g = extractGrams(v.title);
      return v.available && g && g <= 250;
    });
    if (!smallVariants.length) return;

    var baseline = smallVariants.reduce(function(best, v) {
      var g = extractGrams(v.title);
      var ppkg = pricePerKg(v.price, g);
      return (!best || ppkg < best.ppkg) ? { ppkg: ppkg, grams: g } : best;
    }, null);

    if (!baseline) return;

    // Cena jaką zapłaciłbyś za selectedGrams kupując małe paczki
    var equivalentPrice = baseline.ppkg * (selectedGrams / 1000);
    // Cena którą faktycznie płacisz
    var actualPrice = selected.price / 100;
    var saving = ((equivalentPrice - actualPrice) / equivalentPrice * 100);
    if (saving <= 0) return;

    var label = selectedGrams >= 1000 ? (selectedGrams / 1000) + ' kg' : selectedGrams + 'g';

    var badge = document.createElement('div');
    badge.className = 'miga-savings-badge';
    badge.innerHTML =
      '<strong>' + Math.round(saving) + '% taniej</strong>' +
      '<span> za ' + label + ' niż kupując w paczce ' + baseline.grams + 'g</span>';
    container.appendChild(badge);
  }

  function getSelectedVariantId() {
    var input = document.querySelector('input[name="id"]');
    if (input) return input.value;
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function init() {
    updateBadge(getSelectedVariantId());

    document.addEventListener('change', function(e) {
      if (e.target && e.target.name === 'id') {
        updateBadge(e.target.value);
      }
    });

    var lastVariant = getSelectedVariantId();
    setInterval(function() {
      var current = getSelectedVariantId();
      if (current !== lastVariant) {
        lastVariant = current;
        updateBadge(current);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();